import { z } from 'zod';
import { DOCUMENT_ITEM_TYPES, DOCUMENT_PAYMENT_METHODS, DOCUMENT_STATUSES, DOCUMENT_TAX_STRATEGIES, DOCUMENT_TYPES, } from '../constants/documents.js';
import { CREDIT_INSURANCE_STATUSES, INCOTERMS, LEAD_SOURCES, LEAD_STATUSES, PARTNER_RISK_STATUSES, SUPPLIER_RATINGS, } from '../constants/partners.js';
/** Spiegelbilder der Prisma-Enums; Änderungen müssen mit prisma/schema.prisma synchron bleiben. */
export const roleKeySchema = z.enum([
    'OWNER',
    'ADMIN',
    'PURCHASING',
    'SALES',
    'ACCOUNTING',
    'WAREHOUSE',
    'READONLY',
    'CUSTOM',
]);
export const customerTypeSchema = z.enum(['COMPANY', 'PERSON']);
export const customerStatusSchema = z.enum(['ACTIVE', 'PROSPECT', 'BLOCKED', 'INACTIVE']);
export const taxCategorySchema = z.enum([
    'DOMESTIC',
    'EU_B2B',
    'EU_B2C',
    'THIRD_COUNTRY',
    'REVERSE_CHARGE_DOMESTIC',
    'TAX_EXEMPT',
]);
export const vatIdStatusSchema = z.enum([
    'UNCHECKED',
    'VALID',
    'INVALID',
    'NOT_CHECKABLE',
    'SERVICE_UNAVAILABLE',
]);
export const addressTypeSchema = z.enum(['BILLING', 'SHIPPING', 'OTHER']);
export const noteVisibilitySchema = z.enum(['TEAM', 'PRIVATE']);
export const callDirectionSchema = z.enum(['INBOUND', 'OUTBOUND']);
export const callOutcomeSchema = z.enum([
    'REACHED',
    'NOT_REACHED',
    'CALLBACK',
    'ORDER_PLACED',
    'COMPLAINT',
    'NO_INTEREST',
]);
export const leadStatusSchema = z.enum(LEAD_STATUSES);
export const leadSourceSchema = z.enum(LEAD_SOURCES);
export const supplierRatingSchema = z.enum(SUPPLIER_RATINGS);
export const partnerRiskStatusSchema = z.enum(PARTNER_RISK_STATUSES);
export const creditInsuranceStatusSchema = z.enum(CREDIT_INSURANCE_STATUSES);
export const incotermSchema = z.enum(INCOTERMS);
export const customFieldEntitySchema = z.enum([
    'CUSTOMER',
    'CONTACT',
    'ADDRESS',
    'PRODUCT',
    'PRODUCT_PACKAGING',
    'DOCUMENT',
    'DOCUMENT_ITEM',
    'BATCH',
]);
export const customFieldTypeSchema = z.enum([
    'TEXT',
    'TEXTAREA',
    'NUMBER',
    'DECIMAL',
    'DATE',
    'CHECKBOX',
    'SELECT',
    'MULTI_SELECT',
    'FORMULA',
    'WEEKLY_SCHEDULE',
]);
export const documentTypeSchema = z.enum(DOCUMENT_TYPES);
export const productTypeSchema = z.enum(['STOCK', 'NON_STOCK', 'SERVICE', 'SET', 'DEPOSIT']);
export const productStatusSchema = z.enum([
    'ACTIVE',
    'PHASE_OUT',
    'DISCONTINUED',
    'BLOCKED',
    'ARCHIVED',
]);
export const taxRateTypeSchema = z.enum(['STANDARD', 'REDUCED', 'ZERO']);
export const batchStatusSchema = z.enum(['FREE', 'QUARANTINE', 'BLOCKED', 'EXPIRED', 'DEPLETED']);
export const pickingStrategySchema = z.enum(['FEFO', 'FIFO', 'MANUAL']);
export const stockMovementTypeSchema = z.enum([
    'GOODS_RECEIPT',
    'GOODS_ISSUE',
    'TRANSFER_IN',
    'TRANSFER_OUT',
    'ADJUSTMENT',
    'INVENTORY_COUNT',
    'SCRAP',
    'RETURN_IN',
    'RETURN_OUT',
]);
export const stockReferenceTypeSchema = z.enum([
    'MANUAL',
    'ORDER',
    'DELIVERY_NOTE',
    'INVOICE',
    'PURCHASE_ORDER',
    'GOODS_RECEIPT',
    'INVENTORY',
    'PRODUCTION',
]);
export const documentStatusSchema = z.enum(DOCUMENT_STATUSES);
export const paymentStatusSchema = z.enum([
    'OPEN',
    'PARTIALLY_PAID',
    'PAID',
    'OVERDUE',
    'WRITTEN_OFF',
]);
export const documentTaxStrategySchema = z.enum(DOCUMENT_TAX_STRATEGIES);
export const documentPaymentMethodSchema = z.enum(DOCUMENT_PAYMENT_METHODS);
export const documentItemTypeSchema = z.enum(DOCUMENT_ITEM_TYPES);
export const emailTemplateTypeSchema = z.enum([
    'QUOTE_SEND',
    'ORDER_CONFIRMATION',
    'DELIVERY_NOTE_SEND',
    'INVOICE_SEND',
    'CANCELLATION_SEND',
    'REMINDER',
]);
export const emailStatusSchema = z.enum(['SENT', 'FAILED']);
//# sourceMappingURL=enums.js.map